// Server-driven search results. Unlike the other slices these are NOT filters and have no
// entry in DEFAULT_STATE / buildSearchParams - they hold the response of the listing JSON
// endpoint (data/meta/filtersOptions/tags) plus request status, seeded from SSR on mount.
export const initialResultsState = {
  results: [],
  meta: {},
  filtersOptions: {},
  resultTags: [],
  isLoading: false,
  fetchError: null,
  page: 1,
}
